/**
 * Message thrown when a submit path reaches execution with no
 * `withdrawalWallet`. Both rails fail on it before any relay work, so the user
 * sees this rather than a generic wallet failure from deep inside the rail.
 */
export const WALLETLESS_WITHDRAWAL_ERROR =
  'This withdrawal cannot be submitted: no withdrawalWallet was configured, so the SDK has no signer to move the funds.'
